import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import loadScripts from '../../../dassets/js/custom';
class Executor1 extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
        this.onChangePassport = this.onChangePassport.bind(this);
        this.onChangeSignature = this.onChangeSignature.bind(this);
        this.data = {
            passport: null,
            signature: null,
        }
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            title: this.refs._title.value,
            gender: this.refs._gender.value,
            surname: this.refs._surname.value,
            first_name: this.refs._first_name.value,
            other_name: this.refs._other_name.value,
            email: this.refs._email.value,
            dob: this.refs._dob.value,
            marital_status: this.refs._marital_status.value,
            mother_maiden_name: this.refs._mother_maiden_name.value,
            phone1: this.refs._phone1.value,
            phone2: this.refs._phone2.value,
            passport: this.data.passport,
            signature: this.data.signature,
            signature_path: this.data.signature ? `eform_signature_${this.refs._surname.value}_${this.refs._first_name.value}_${new Date().getTime()}.png` : null,
            passport_path: this.data.passport ? `eform_passport_${this.refs._surname.value}_${this.refs._first_name.value}_${new Date().getTime()}.png` : null,
        }

        this.props.saveValues(data, 'executor', 1)
        this.props.nextStep()
    }

    onChangePassport(e) {
        const fileTypes = ['image/png', 'image/gif', 'image/jpeg'];

        let file = e.target.files[0];
        if (fileTypes.every(extension => file.type !== extension)) {
            toast.error(`The file ${file.type} extension is not supported`);
            return
        }
        this.data.passport = file;
    }

    onChangeSignature(e) {
        const fileTypes = ['image/png', 'image/gif', 'image/jpeg'];

        let file = e.target.files[0];
        if (fileTypes.every(extension => file.type !== extension)) {
            toast.error(`The file ${file.type} extension is not supported`);
            return
        }
        this.data.signature = file;
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Executor 2</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Title</label>
                                            <select ref="_title" className="form-control" defaultValue={this.props.fieldValues.title}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Mr">Mr</option>
                                                <option value="Miss">Miss</option>
                                                <option value="Mrs">Mrs</option>
                                                <option value="Chief">Chief</option>
                                                <option value="Dr.">Dr.</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Surname</label>
                                            <Form.Control type="text" className="form-control" ref="_surname" placeholder="Surname" defaultValue={this.props.fieldValues.surname} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>First Name</label>
                                            <Form.Control type="text" className="form-control" ref="_first_name" placeholder="First Name" defaultValue={this.props.fieldValues.first_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Other Name</label>
                                            <Form.Control type="text" className="form-control" ref="_other_name" placeholder="Other Name" defaultValue={this.props.fieldValues.other_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Gender</label>
                                            <select ref="_gender" className="form-control" defaultValue={this.props.fieldValues.gender}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Email Address</label>
                                            <Form.Control type="email" className="form-control" ref="_email" placeholder="Email Address" defaultValue={this.props.fieldValues.email} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Date of Birth</label>
                                            <Form.Control type="date" className="form-control" ref="_dob" placeholder="Date of Birth" defaultValue={this.props.fieldValues.dob} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Marital Status</label>
                                            <select ref="_marital_status" className="form-control" defaultValue={this.props.fieldValues.marital_status}>
                                                <option value="" hidden>Select...</option>
                                                <option value="N/A">N/A</option>
                                                <option value="Single">Single</option>
                                                <option value="Married">Married</option>
                                                <option value="Divorced">Divorced</option>
                                                <option value="Widowed">Widowed</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Mother's Maiden Name</label>
                                            <Form.Control type="text" className="form-control" ref="_mother_maiden_name" placeholder="Mother's Maiden Name" defaultValue={this.props.fieldValues.mother_maiden_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Mobile No</label>
                                            <Form.Control type="text" className="form-control uint" ref="_phone1" placeholder="Mobile No" defaultValue={this.props.fieldValues.phone1} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Alternative No</label>
                                            <Form.Control type="text" className="form-control uint" ref="_phone2" placeholder="Alternative No" defaultValue={this.props.fieldValues.phone2} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label htmlFor="attachments"><i className="fa fa-paperclip"></i> Passport</label>
                                            <Form.Control onChange={this.onChangePassport} type="file" className="form-control" ref="passport" accept=".jpeg,.jpg,.gif,.png" />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label htmlFor="attachments"><i className="fa fa-paperclip"></i> Signature</label>
                                            <Form.Control onChange={this.onChangeSignature} type="file" className="form-control" ref="attachments" accept=".jpeg,.jpg,.gif,.png" />
                                        </Form.Group>
                                    </div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Executor1;